import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useGetBroadcasts, useGetMyAccount } from "@/api/queries";
import useSiteConfigAuth from "@/api/sanity/queries/getSiteConfigWithCode";
import BroadcastsTable from "@/components/BroadcastsTable";
import H2 from "@/components/H2";
import P from "@/components/P";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function Broadcasts() {
  const { t } = useTranslation("other");
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  // const navigate = useNavigate();

  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });

  const broadcasts = useGetBroadcasts({
    ac: selectedAccount,
    oc: myAccount?.data?.originatorcode?.code,
  });

  useEffect(() => {
    if (selectedAccount) {
      broadcasts.refetch();
    }
  }, [selectedAccount, broadcasts]);

  const { data: siteConfig } = useSiteConfigAuth();
  const navigate = useNavigate();
  const noBroadcasts = siteConfig?.disable_broadcasts;
  useEffect(() => {
    if (noBroadcasts) {
      navigate({ to: "/" });
    }
  }, [noBroadcasts, navigate]);

  return (
    <div className="flex-1 order-last xl:w-full bg-sentric-rebrand-light-grey min-h-50 lg:min-h-screen-minus-header">
      <H2>{t("other:your-broadcasts-header")}</H2>
      <Spacer thin />
      <P className="font-sentric-alt" small>
        {t("other:your-broadcasts-text")}
      </P>
      <Spacer />
      <BroadcastsTable />
    </div>
  );
}
export default Broadcasts;
